// redux/actions/class.ts

export interface ClassStudent {
  id: string;
  name: string;
  statistic: {
    averageScore: number;
  };
}

export interface ClassStudentsPayload {
  classId: string;
  students: ClassStudent[];
}

export const SET_SELECTED_CLASS = 'SET_SELECTED_CLASS';
export const SET_CLASS_STUDENTS = 'SET_CLASS_STUDENTS';

export const setSelectedClass = (classId: string) => ({
  type: SET_SELECTED_CLASS as typeof SET_SELECTED_CLASS,
  payload: classId,
});

export const setClassStudents = (payload: ClassStudentsPayload) => ({
  type: SET_CLASS_STUDENTS as typeof SET_CLASS_STUDENTS,
  payload,
});

export type ClassActions =
  | ReturnType<typeof setSelectedClass>
  | ReturnType<typeof setClassStudents>;
